module.exports = __webpack_public_path__ + "static/pga-junior-league-camps-66535ef89a2094bc09823a8532d44bab.png";